{
  "01_burumoments": {
    "01_beach": {
      "cards": [
        "burumoments_beach_01",
        "burumoments_beach_02",
        "burumoments_beach_03",
        "burumoments_beach_04",
        "burumoments_beach_05",
        "burumoments_beach_06",
        "burumoments_beach_07",
        "burumoments_beach_08",
        "burumoments_beach_09"
      ],
      "rewards": [
        {
          "type": "wrapper",
          "subType": "all_powerups",
          "amount": 2
        },
        {
          "type": "gems",
          "amount": 25
        },
        {
          "type": "bPoints",
          "amount": 1000
        }
      ]
    },
    "02_gym": {
      "cards": [
        "burumoments_gym_01",
        "burumoments_gym_02",
        "burumoments_gym_03",
        "burumoments_gym_04",
        "burumoments_gym_05",
        "burumoments_gym_06",
        "burumoments_gym_07",
        "burumoments_gym_08",
        "burumoments_gym_09"
      ],
      "rewards": [
        {
          "type": "wrapper",
          "subType": "all_powerups",
          "amount": 2
        },
        {
          "type": "gems",
          "amount": 25
        },
        {
          "type": "bPoints",
          "amount": 1000
        }
      ]
    },
    "03_shopping": {
      "cards": [
        "burumoments_shopping_01",
        "burumoments_shopping_02",
        "burumoments_shopping_03",
        "burumoments_shopping_04",
        "burumoments_shopping_05",
        "burumoments_shopping_06",
        "burumoments_shopping_07",
        "burumoments_shopping_08",
        "burumoments_shopping_09"
      ],
      "rewards": [
        {
          "type": "wrapper",
          "subType": "all_powerups",
          "amount": 2
        },
        {
          "type": "gems",
          "amount": 25
        },
        {
          "type": "bPoints",
          "amount": 1000
        }
      ]
    },
    "04_pool": {
      "cards": [
        "burumoments_pool_01",
        "burumoments_pool_02",
        "burumoments_pool_03",
        "burumoments_pool_04",
        "burumoments_pool_05",
        "burumoments_pool_06",
        "burumoments_pool_07",
        "burumoments_pool_08",
        "burumoments_pool_09"
      ],
      "rewards": [
        {
          "type": "wrapper",
          "subType": "all_powerups",
          "amount": 2
        },
        {
          "type": "gems",
          "amount": 25
        },
        {
          "type": "bPoints",
          "amount": 1000
        }
      ]
    },
    "05_cafe": {
      "cards": [
        "burumoments_cafe_01",
        "burumoments_cafe_02",
        "burumoments_cafe_03",
        "burumoments_cafe_04",
        "burumoments_cafe_05",
        "burumoments_cafe_06",
        "burumoments_cafe_07",
        "burumoments_cafe_08",
        "burumoments_cafe_09"
      ],
      "rewards": [
        {
          "type": "wrapper",
          "subType": "all_powerups",
          "amount": 2
        },
        {
          "type": "gems",
          "amount": 25
        },
        {
          "type": "bPoints",
          "amount": 1000
        }
      ]
    },
    "06_onsen": {
      "cards": [
        "burumoments_onsen_01",
        "burumoments_onsen_02",
        "burumoments_onsen_03",
        "burumoments_onsen_04",
        "burumoments_onsen_05",
        "burumoments_onsen_06",
        "burumoments_onsen_07",
        "burumoments_onsen_08",
        "burumoments_onsen_09"
      ],
      "rewards": [
        {
          "type": "wrapper",
          "subType": "all_powerups",
          "amount": 2
        },
        {
          "type": "gems",
          "amount": 25
        },
        {
          "type": "bPoints",
          "amount": 1000
        }
      ]
    },
    "07_camping": {
      "cards": [
        "burumoments_camping_01",
        "burumoments_camping_02",
        "burumoments_camping_03",
        "burumoments_camping_04",
        "burumoments_camping_05",
        "burumoments_camping_06",
        "burumoments_camping_07",
        "burumoments_camping_08",
        "burumoments_camping_09"
      ],
      "rewards": [
        {
          "type": "wrapper",
          "subType": "all_powerups",
          "amount": 2
        },
        {
          "type": "gems",
          "amount": 25
        },
        {
          "type": "bPoints",
          "amount": 1000
        }
      ]
    },
    "08_playground": {
      "cards": [
        "burumoments_playground_01",
        "burumoments_playground_02",
        "burumoments_playground_03",
        "burumoments_playground_04",
        "burumoments_playground_05",
        "burumoments_playground_06",
        "burumoments_playground_07",
        "burumoments_playground_08",
        "burumoments_playground_09"
      ],
      "rewards": [
        {
          "type": "wrapper",
          "subType": "all_powerups",
          "amount": 2
        },
        {
          "type": "gems",
          "amount": 25
        },
        {
          "type": "bPoints",
          "amount": 1000
        }
      ]
    },
    "09_disco": {
      "cards": [
        "burumoments_karaoke_01",
        "burumoments_karaoke_02",
        "burumoments_karaoke_03",
        "burumoments_karaoke_04",
        "burumoments_karaoke_05",
        "burumoments_karaoke_06",
        "burumoments_karaoke_07",
        "burumoments_karaoke_08",
        "burumoments_karaoke_09"
      ],
      "rewards": [
        {
          "type": "wrapper",
          "subType": "all_powerups",
          "amount": 2
        },
        {
          "type": "gems",
          "amount": 25
        },
        {
          "type": "bPoints",
          "amount": 1000
        }
      ]
    }
  }
}
